'use client'
import { type ReactNode, useState, useEffect } from 'react'
import styled from 'styled-components'
import { motion, type Variants } from 'motion/react'
import { useDeviceType } from '@/hooks'
import { Nav } from '@/components/Nav'

let LAST_DEVICE_TYPE = 'desktop'
export default function PrivateLayout({ children }: { children: ReactNode }) {
  const [navCollapsed, setNavCollapsed] = useState(false)
  const { deviceType } = useDeviceType()

  useEffect(() => {
    if (deviceType !== LAST_DEVICE_TYPE) {
      LAST_DEVICE_TYPE = deviceType
      setNavCollapsed(deviceType === 'mobile')
    }
  }, [deviceType])


  return (
    <>
      <Nav navCollapsed={navCollapsed} setNavCollapsed={setNavCollapsed} />
      <Div variants={variants} initial={'expanded'} animate={navCollapsed ? 'collapsed' : 'expanded'}>
        {children}
      </Div>
    </>
  )
}

const Div = styled(motion.div)`
  background: var(--color-background);
  height: 100%;

  @media screen and (max-width: 767px) {
    margin-left: 0!important;
  }

  main {
    max-width: 1920px;
    position: relative;
  }
`

const transition = {
  duration: .3,
  type: 'tween',
  ease: [.25, .1, .25, 1],
} as const

const variants:Variants = {
  collapsed: {
    marginLeft: '60px',
    transition
  },
  expanded: {
    marginLeft: '200px',
    transition
  }
}
